import { Component } from '@angular/core';
import {
  AbstractControl,
  Form,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  Airport,
  CloudSearchResponseItem,
  CommunityItem,
  CompanionItem,
  CountryItem,
  DtoCreateMediaFromCloud,
  DtoTravelCreate,
  DtoTravelCreateDraft,
  FlightCompany,
  FlightDraftWrapper,
  MediaItem,
  MediaItemWrapper,
  RegistryItem,
  RegistryItemMinimal,
  TravelAssignment,
  TravelCategory,
  TravelDraft,
  TravelDraftMinimal,
  TravelItem,
  TravelPackage,
  UserItem,
  UserItemMinimal,
} from '../../../api/models';
import {
  CommonService,
  CommunityService,
  CountryService,
  IdentityService,
  RegistryService,
  TravelService,
} from '../../../api/services';
import { AuthService } from '../../../guards/services/auth.service';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  filter,
  from,
  map,
  of,
  range,
  switchMap,
} from 'rxjs';
import { CountryControllerGetAll$Params } from '../../../api/fn/country/country-controller-get-all';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { ModalImagePickerComponent } from '../../../shared/modals/modal-image-picker/modal-image-picker.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { correctDate } from '../../../shared/utils/utils';
import { RegistryControllerGetAll$Params } from '../../../api/fn/registry/registry-controller-get-all';
import { ModalNewCompanionComponent } from '../../../shared/modals/modal-new-companion/modal-new-companion.component';
import { Title } from '@angular/platform-browser';
import { ModalFilePickerComponent } from '../../../shared/modals/modal-file-picker/modal-file-picker.component';
import { CloudImagePickerComponent } from '../../../shared/modals/cloud-image-picker/cloud-image-picker.component';
import { IdentityControllerGetAll$Params } from '../../../api/fn/identity/identity-controller-get-all';
import { enumUserRole } from '../../../shared/utils/enum-user-role';
import { enumAssignmentStatus } from '../../../shared/utils/enum-assignment-request';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import { EnumEventType } from '../../../shared/utils/enum-event-type';

@Component({
  selector: 'app-new-travel',
  templateUrl: './new-travel.component.html',
  styleUrl: './new-travel.component.scss',
})
export class NewTravelComponent {
  visible: boolean = false; // per modale termini e condizioni
  menuIndex = 0;
  types: TravelCategory[] = [];
  visibility_opt: { name: string; id: number }[] = [
    { name: 'Pubblico', id: 1 },
    { name: 'Privato', id: 2 },
  ];
  isPrivate = false;
  isUpdate = false;
  throughCommunity = false;
  communities: CommunityItem[] = [];
  autocompleteCountries$ = new BehaviorSubject<string>('');
  suggestedCountries: CountryItem[] = [];
  autocompletePlayers$ = new BehaviorSubject<string>('');
  suggestedPlayers: RegistryItemMinimal[] = [];
  autocompleteCompanions$ = new BehaviorSubject<string>('');
  imagePickerRef: DynamicDialogRef | undefined;
  companies: FlightCompany[] = [];
  airports: Airport[] = [];
  currency: { name: string; symbol: string }[] = [
    { name: 'EUR', symbol: '€' },
    { name: 'USD', symbol: '$' },
  ];
  installments_n: { name: string; id: number }[] = [
    { name: '1', id: 1 },
    { name: '2', id: 2 },
    { name: '3', id: 3 },
    { name: '4', id: 4 },
    { name: '5', id: 5 },
    { name: '6', id: 6 },
  ];
  loading = false;
  imgLoading = false;
  loading_luggage_attachment = false;
  loading_cancellation_attachment = false;
  draft_id?: number;
  travel_id?: number;
  travel_data?: TravelDraft;
  rangeDates = new FormControl<(Date | undefined)[] | undefined>(undefined);
  payoff_due_date_control = new FormControl<Date | undefined>(undefined);
  travel_img?: MediaItemWrapper[];
  has_sponsor = new FormControl(false);
  items_menu_check: MenuItem[] | undefined;
  player = new FormControl<RegistryItem | undefined>(undefined);
  companion?: CompanionItem;
  newCompanionRef: DynamicDialogRef | undefined;
  form_section_validation = new Map<
    string,
    { fields: string[]; valid: boolean }
  >();
  openFileRef: DynamicDialogRef | undefined;
  today = new Date();
  travel_from?: Date;
  travel_to?: Date;
  luggage_attachment?: MediaItem;
  cancellation_attachment?: MediaItem;
  acceptedSeparators: RegExp = /[;\n-]/; //punto e virgola, testo a capo, trattino alto
  imageFromCloudPickerRef: DynamicDialogRef | undefined;
  tourleaders: UserItem[] = [];
  autocompleteTourLeaders$ = new BehaviorSubject<string>('');
  suggestedTourLeaders: UserItemMinimal[] = [];
  assignedTourleader = new FormControl<UserItem | UserItemMinimal | undefined>(
    undefined
  );
  enumUserRoles = enumUserRole;
  requestDone = false;
  isPending = false;
  enumAssignmentStatus = enumAssignmentStatus;
  // children_and_infants_ok = new FormControl<boolean>(true);
  travel_type: EnumEventType = EnumEventType.STANDARD;
  EnumEventType = EnumEventType;

  frm_travel: FormGroup = new FormGroup({
    //INFORMAZIONI BASE
    visibility: new FormControl<number>(1),
    visibility_id: new FormControl<number>(1),
    visibility_metadata: new FormControl<number[] | undefined>(undefined),
    undisclosed_members_list: new FormControl(false),
    name: new FormControl(''),
    payoff: new FormControl(''),
    summary: new FormControl(''),
    countries_iso: new FormControl<string[] | null>(null, {
      validators: [Validators.required],
      nonNullable: true,
    }),
    cities: new FormControl<string[]>([]),
    max_members: new FormControl<number | undefined>(
      undefined,
      Validators.required
    ),
    categories: new FormControl<number[] | undefined>(undefined),
    companion_id: new FormControl<number | undefined>(undefined),
    //VOLI
    has_flights: new FormControl(true),
    optional_flight_purchase: new FormControl(false),
    optional_flight_purchase_discount: new FormControl<number | undefined>(
      undefined
    ),
    departures: new FormArray<
      FormGroup<{
        flight_company: FormControl;
        flight_number: FormControl;
        from_airport: FormControl;
        to_airport: FormControl;
        departure_date: FormControl;
        arrival_date: FormControl;
      }>
    >([]),
    arrivals: new FormArray<
      FormGroup<{
        flight_company: FormControl;
        flight_number: FormControl;
        from_airport: FormControl;
        to_airport: FormControl;
        departure_date: FormControl;
        arrival_date: FormControl;
      }>
    >([]),
    //DESCRIZIONE
    program: new FormArray<
      FormGroup<{
        title: FormControl;
        description: FormControl;
      }>
    >([]),
    price_includes: new FormControl<string[]>([]),
    price_excludes: new FormControl<string[]>([]),
    youtube_url: new FormControl(''),
    //PAGAMENTI
    currency: new FormControl<string | undefined>('EUR'),
    price_room: new FormControl<number | undefined>(0, Validators.required),
    price_addl_single: new FormControl<number | undefined>(
      0,
      Validators.required
    ),
    price_sub_triple: new FormControl<number | undefined>(
      0,
      Validators.required
    ),
    price_sub_quad: new FormControl<number | undefined>(0, Validators.required),
    price_sub_infant: new FormControl<number | undefined>(
      0,
      Validators.required
    ),
    price_sub_child: new FormControl<number | undefined>(
      0,
      Validators.required
    ),
    checkout_full_payment: new FormControl<boolean>(false),
    checkout_advance: new FormControl<number | undefined>(undefined),
    checkout_number_of_installments: new FormControl<number | undefined>(0),
    terms_and_conds: new FormControl(undefined),
    customer_pays_fees: new FormControl(false),
    payoff_due_date: new FormControl<string | undefined>(undefined),
    //PACCHETTI
    pricing_mode: new FormControl<number | undefined>(undefined),
    price_packages: new FormArray<
      FormGroup<{
        name: FormControl;
        description: FormControl;
        price_per_person: FormControl;
        price_per_infant: FormControl;
        price_per_children: FormControl;
        limited: FormControl;
        tmp_children_and_infants_ok: FormControl;
        n_partecipants: FormControl;
        max_bookings: FormControl;
        max_n_infants: FormControl;
        max_n_children: FormControl;
      }>
    >([]),
    //SERVIZI AGGIUNTIVI
    addl_services: new FormArray<
      FormGroup<{
        title: FormControl;
        description: FormControl;
        price: FormControl;
      }>
    >([]),
  });

  constructor(
    private communityService: CommunityService,
    public auth: AuthService,
    private countryService: CountryService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private commonService: CommonService,
    private travelService: TravelService,
    private router: Router,
    private ar: ActivatedRoute,
    private regService: RegistryService,
    private title: Title,
    private userService: IdentityService,
    private slugifyPipe: SlugifyPipe
  ) {}
  setValidationStandard() {
    this.form_section_validation.set('section_0', {
      fields: [
        'visibility',
        'visibility_metadata',
        'name',
        'payoff',
        'summary',
        'rangeDates',
        'countries_iso',
        'cities',
        'max_members',

        'categories',
        'companion_id',
      ],
      valid: true,
    });
    this.form_section_validation.set('section_1', {
      fields: [
        'departures.flight_company',
        'departures.flight_number',
        'departures.from_airport',
        'departures.to_airport',
        'departures.departure_date',
        'departures.arrival_date',
        'arrivals.flight_company',
        'arrivals.flight_number',
        'arrivals.from_airport',
        'arrivals.to_airport',
        'arrivals.departure_date',
        'arrivals.arrival_date',
      ],
      valid: true,
    });
    this.form_section_validation.set('section_2', {
      fields: ['title', 'description', 'price_includes', 'price_excludes'],
      valid: true,
    });
    // this.form_section_validation.set('section_3', {
    //   fields: [
    //     'price_room',
    //     'price_addl_single',
    //     'price_sub_triple',
    //     'price_sub_quad',
    //     'price_sub_infant',
    //     'price_sub_child',
    //     'checkout_advance',
    //     'terms_and_conds',
    //   ],
    //   valid: true,
    // });
    // this.form_section_validation.set('section_3', {
    //   fields: [
    //     'price_packages.name',
    //     'price_packages.description',
    //     'price_packages.price_per_person',
    //     'price_packages.n_partecipants',
    //     'price_packages.price_per_infant',
    //     'price_packages.price_per_children',
    //     'price_packages.max_n_children',
    //     'price_packages.max_n_infants',
    //     'price_packages.checkout_advance',
    //     'price_packages.terms_and_conds',
    //   ],
    //   valid: true,
    // });
    if (this.travel_data?.pricing_mode === 2) {
      // modalità pacchetti
      this.form_section_validation.set('section_3', {
        fields: ['terms_and_conds'],
        valid: true,
      });
    } else {
      // modalità standard
      this.form_section_validation.set('section_3', {
        fields: [
          'price_packages.name',
          'price_packages.description',
          'price_packages.price_per_person',
          'price_packages.n_partecipants',
          'price_packages.price_per_infant',
          'price_packages.price_per_children',
          'price_packages.max_n_children',
          'price_packages.max_n_infants',
          'price_packages.checkout_advance',
          'price_packages.terms_and_conds',
          'terms_and_conds',
        ],
        valid: true,
      });
    }

    this.form_section_validation.set('section_4', {
      fields: ['title', 'description', 'price'],
      valid: true,
    });
  }
  setValidationGMG() {
    this.form_section_validation.set('section_0', {
      fields: [
        'name',
        'countries_iso',
        'cities',
        'visibility',
        'visibility_metadata',
      ],
      valid: true,
    });

    this.form_section_validation.set('section_3', {
      fields: ['terms_and_conds'],
      valid: true,
    });
  }
  ngOnInit() {
    this.title.setTitle('SocialTravels - Modulo del viaggio');
    this.ar.params.subscribe((p: Params) => {
      this.getMyCommunities();
      this.getTravelTypes();
      this.getFlightCompanies();
      this.getAirports();
      // EDIT TRAVEL
      if (p['travel_id']) {
        this.travel_id = p['travel_id'];
        this.isUpdate = true;
        this.travelService
          .travelControllerGetTravel({ id: this.travel_id! })
          .subscribe({
            next: (res) => {
              this.travel_data = res.data;
              if (
                this.ar.snapshot.data['travel_type'] === EnumEventType.STANDARD // controllo che draft sia tipo standard e applico i suoi validatori
              ) {
                this.setValidationStandard();
                this.setVisibilityValueChanges();
                this.patchValueForm();
                this.subscribeToFormChanges();
              }
              if (
                this.ar.snapshot.data['travel_type'] === EnumEventType.GMG // controllo che draft sia tipo standard e applico i suoi validatori
              ) {
                this.travel_type = EnumEventType.GMG;
                //draft tipo GMG con i suoi validatori
                this.setValidationGMG();
                this.setVisibilityValueChanges();
                this.patchValueForm();
                this.subscribeToFormChanges();
              }
            },
          });
      }
      // EDIT DRAFT
      else if (p['id']) {
        this.draft_id = p['id'];
        this.isUpdate = false;
        this.travelService
          .travelControllerGetDraft({ id: this.draft_id! })
          .subscribe({
            next: (res) => {
              this.travel_data = res.data;
              if (
                this.ar.snapshot.data['travel_type'] === EnumEventType.STANDARD // controllo che draft sia tipo standard e applico i suoi validatori
              ) {
                this.setValidationStandard();

                this.patchValueForm();
                this.subscribeToFormChanges();
                this.setVisibilityValueChanges();
                if (res.data.departures?.length === 0) {
                  this.addDepartureFlight();
                }
                if (res.data.arrivals?.length === 0) {
                  this.addArrivalFlight();
                }
              } else if (
                this.ar.snapshot.data['travel_type'] === EnumEventType.GMG // controllo che draft sia tipo gmg e applico i suoi validatori)
              ) {
                this.travel_type = EnumEventType.GMG;
                this.setValidationGMG();
                this.patchValueForm();
                this.subscribeToFormChanges();
                this.setVisibilityValueChanges();
              }
            },
          });
      }
      // NEW
      else {
        //VIAGGIO STANDARD
        if (this.ar.snapshot.data['travel_type'] === EnumEventType.STANDARD) {
          this.travelService.travelControllerCreateDraft().subscribe({
            next: (res) => {
              this.draft_id = res.data.id;
              this.travelService
                .travelControllerGetTravel({ id: this.draft_id! })
                .subscribe({
                  next: (res) => {
                    this.travel_data = res.data;
                    this.frm_travel
                      .get('pricing_mode')
                      ?.setValue(this.travel_data.pricing_mode);
                    this.setValidationStandard();
                    this.addDepartureFlight();
                    this.addArrivalFlight();
                    this.addProgramDay();
                    this.addService();
                    this.addPackage();
                    this.setVisibilityValueChanges();
                    this.subscribeToFormChanges();

                    if (
                      !this.travel_data.player &&
                      this.auth.isTourLeaderPro()
                    ) {
                      this.player.patchValue(
                        this.auth.user.value?.related_registry
                      );
                    }
                  },
                });
            },
          });
        }
        // VIAGGIO GMG
        if (this.ar.snapshot.data['travel_type'] === EnumEventType.GMG) {
          this.travel_type = EnumEventType.GMG;
          this.travelService.travelControllerCreateFundingDraft().subscribe({
            next: (res) => {
              this.draft_id = res.data.id;

              this.travelService
                .travelControllerGetTravel({ id: this.draft_id! })
                .subscribe({
                  next: (res) => {
                    this.travel_data = res.data;
                    this.frm_travel
                      .get('visibility_id')
                      ?.setValue(2, { emitEvent: false });
                    this.frm_travel
                      .get('visibility_metadata')
                      ?.setValue(undefined);
                    this.setValidationGMG();
                    this.patchValueForm(true);
                    this.setVisibilityValueChanges();
                    this.subscribeToFormChanges();
                    //mostro la modale dopo 2 sec dal caricamento dei dati della chiamata
                    setTimeout(() => {
                      this.visible = true;
                    }, 2000);
                  },
                });
            },
          });
        }
      }
      this.items_menu_check = [
        {
          label: 'Salva',
          icon: 'pi pi-save',
          visible: this.isUpdate,
          command: () => {
            this.updateTravel();
          },
        },
        {
          label: 'Vai alle bozze',
          icon: 'pi pi-arrow-right',
          command: () => {
            this.redirect();
          },
        },
        {
          label: 'Pubblica',
          icon: 'pi pi-eye',
          command: () => {
            this.publish();
          },
        },
      ];
    });

    this.autocompleteCountries$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          if (query) {
            let params: CountryControllerGetAll$Params = {
              query,
            };
            return this.countryService.countryControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: (res) => {
          this.suggestedCountries = res.data.list;
        },
      });

    this.autocompletePlayers$
      .pipe(
        debounceTime(300),
        map((v) => v || ''),
        filter((v) => v != null && v.length > 0),
        distinctUntilChanged(),
        switchMap((query) => {
          const params: RegistryControllerGetAll$Params = {
            limit: 100,
            skip: 0,
            query,
            //contact_types: [1]
          };
          if (query) {
            return this.regService.registryControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: (res) => {
          this.suggestedPlayers = res.data.list;
        },
      });

    this.autocompleteTourLeaders$
      .pipe(
        debounceTime(300),
        map((v) => v || ''),
        filter((v) => v != null && v.length > 0),
        distinctUntilChanged(),
        switchMap((query) => {
          const params: IdentityControllerGetAll$Params = {
            limit: 100,
            skip: 0,
            query,
            roles: [enumUserRole.TOURLEADER, enumUserRole.TOURLEADER_PRO],
            //contact_types: [1]
          };
          if (query) {
            return this.userService.identityControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: (res) => {
          this.suggestedTourLeaders = res.data.list.filter(
            (x) => x.id != this.auth.getUserId()
          );
        },
      });

    this.rangeDates.valueChanges.subscribe(() => {
      if (this.rangeDates.value && this.rangeDates.value[0]) {
        this.travel_from = this.rangeDates.value[0];
        if (
          this.frmDepControls.length > 0 &&
          !this.frmDepControls[0].get('departure_date')?.value
        ) {
          this.frmDepControls[0]
            .get('departure_date')
            ?.setValue(this.travel_from);
          this.frmDepControls[0]
            .get('arrival_date')
            ?.setValue(this.travel_from);
        }
      } else {
        this.travel_from = undefined;
      }
      if (this.rangeDates.value && this.rangeDates.value[1]) {
        this.travel_to = this.rangeDates.value[1];
        if (
          this.frmArrControls.length > 0 &&
          !this.frmArrControls[0].get('departure_date')?.value
        ) {
          this.frmArrControls[0]
            .get('departure_date')
            ?.setValue(this.travel_to);
          this.frmArrControls[0].get('arrival_date')?.setValue(this.travel_to);
        }
      } else {
        this.travel_to = undefined;
      }
    });

    if (this.travel_data?.payoff_due_date) {
      this.payoff_due_date_control.valueChanges.subscribe((v) => {
        if (v) {
          this.frm_travel.get('payoff_due_date')?.setValue(v.toISOString());
        }
      });
    }

    this.frm_travel.get('has_flights')?.valueChanges.subscribe((v) => {
      if (v === false) {
        this.frm_travel.get('optional_flight_purchase')?.setValue(false);
      }
    });
  }

  patchValueForm(exclude_visibility?: boolean) {
    //VISIBILITY
    if (exclude_visibility) {
      delete this.travel_data!.visibility;
      delete this.travel_data!.visibility_metadata;
    }
    this.frm_travel.patchValue(this.travel_data!);
    if (!exclude_visibility) {
      if (this.travel_data!.visibility?.id === 1) {
        this.frm_travel.get('visibility')?.patchValue(1);
        this.frm_travel
          .get('visibility_id')
          ?.patchValue(this.travel_data!.visibility?.id);
      }
      if (this.travel_data!.visibility?.id === 2) {
        this.frm_travel.get('visibility')?.patchValue(2);
        this.isPrivate = true;
        this.frm_travel.get('visibility_id')?.patchValue(2);
      }
      if (this.travel_data!.visibility?.id === 3) {
        this.frm_travel.get('visibility')?.patchValue(2);
        this.isPrivate = true;
        this.frm_travel.get('visibility_id')?.patchValue(3);
      }
      if (this.travel_data!.visibility?.id === 4) {
        this.frm_travel.get('visibility')?.patchValue(2);
        this.isPrivate = true;
        this.throughCommunity = true;
        this.frm_travel.get('visibility_id')?.patchValue(4);
        this.frm_travel
          .get('visibility_metadata')
          ?.patchValue(
            (this.travel_data?.visibility_metadata as any[]).map((x) => x.id)
          );
      }
    }
    //PAESI
    if (this.travel_data!.countries) {
      this.frm_travel
        .get('countries_iso')
        ?.patchValue(this.travel_data!.countries?.map((x) => x.country));
    }
    //DATE
    let from_to: (Date | undefined)[] | undefined = undefined;
    if (
      this.travel_data!.from_date !== null &&
      this.travel_data!.to_date !== null
    ) {
      from_to = [
        new Date(this.travel_data!.from_date!),
        new Date(this.travel_data!.to_date!),
      ];
    } else if (this.travel_data!.from_date !== null) {
      from_to = [new Date(this.travel_data!.from_date!), undefined];
    } else if (this.travel_data!.to_date !== null) {
      from_to = [undefined, new Date(this.travel_data!.to_date!)];
    }
    this.rangeDates.setValue(from_to);

    if (this.travel_data!.payoff_due_date) {
      this.payoff_due_date_control.setValue(
        new Date(this.travel_data!.payoff_due_date)
      );
    }

    //CATEGORIE
    if (this.travel_data!.categories) {
      this.frm_travel
        .get('categories')
        ?.patchValue(this.travel_data!.categories.map((x) => x.category.id));
    }
    //VOLI
    if (this.travel_data!.departures) {
      (this.frm_travel.get('departures') as FormArray)!.clear();
      for (let f of this.travel_data!.departures) {
        const frm_dep = new FormGroup({
          id: new FormControl(f.flight.id),
          flight_company: new FormControl(f.flight.flight_company?.code),
          flight_number: new FormControl(f.flight.flight_number),
          from_airport: new FormControl(f.flight.from_airport?.code),
          to_airport: new FormControl(f.flight.to_airport?.code),
          departure_date: new FormControl(
            f.flight.departure_date === null ||
            f.flight.departure_date == '1/1/1970'
              ? ''
              : new Date(f.flight.departure_date!)
          ),
          arrival_date: new FormControl(
            f.flight.arrival_date === null ||
            f.flight.arrival_date == '1/1/1970'
              ? ''
              : new Date(f.flight.arrival_date!)
          ),
        });
        (this.frm_travel.get('departures') as FormArray)!.push(frm_dep);
        // console.log('frm_dep pushed: ',frm_dep.value, 'frm_travel: ', this.frm_travel.get('departures')?.value)
      }
    }
    if (this.travel_data!.arrivals) {
      (this.frm_travel.get('arrivals') as FormArray)!.clear();
      for (let f of this.travel_data!.arrivals) {
        const frm_arr = new FormGroup({
          id: new FormControl(f.flight.id),
          flight_company: new FormControl(f.flight.flight_company?.code),
          flight_number: new FormControl(f.flight.flight_number),
          from_airport: new FormControl(f.flight.from_airport?.code),
          to_airport: new FormControl(f.flight.to_airport?.code),
          departure_date: new FormControl(
            f.flight.departure_date === null ||
            f.flight.departure_date == '1/1/1970'
              ? ''
              : new Date(f.flight.departure_date!)
          ),
          arrival_date: new FormControl(
            f.flight.arrival_date === null ||
            f.flight.arrival_date == '1/1/1970'
              ? ''
              : new Date(f.flight.arrival_date!)
          ),
        });
        (this.frm_travel.get('arrivals') as FormArray)!.push(frm_arr);
      }
    }
    //PROGRAMMA
    if (this.travel_data!.program) {
      if (this.travel_data!.program.length > 0) {
        (this.frm_travel.get('program') as FormArray)!.clear();
        for (let p of this.travel_data!.program as any[]) {
          const frm_day = new FormGroup({
            title: new FormControl(p.title),
            description: new FormControl(p.description),
          });
          (this.frm_travel.get('program') as FormArray)!.push(frm_day);
        }
      } else {
        this.addProgramDay();
      }
    }
    //VALUTA
    if (this.travel_data!.currency) {
      this.frm_travel.get('currency')?.patchValue(this.travel_data!.currency);
    }
    //SERVIZI AGGIUNTIVI
    if (this.travel_data!.addl_services) {
      if (this.travel_data!.addl_services.length > 0) {
        (this.frm_travel.get('addl_services') as FormArray).clear();
        for (let s of this.travel_data!.addl_services as any[]) {
          const frm_service = new FormGroup({
            title: new FormControl(s.title),
            description: new FormControl(s.description),
            price: new FormControl<number | undefined>(s.price),
          });
          (this.frm_travel.get('addl_services') as FormArray)!.push(
            frm_service
          );
        }
      } else {
        this.addService();
      }
    }
    //IMMAGINE
    if (this.travel_data!.medias) {
      this.travel_img = this.travel_data!.medias?.sort(
        (a, b) => a.media.id - b.media.id
      );
    }

    //FORNITORE ESTERNO
    if (this.travel_data!.player) {
      this.player.patchValue(this.travel_data!.player);
    }
    //TL PRO
    if (!this.travel_data!.player && this.auth.isTourLeaderPro()) {
      this.player.patchValue(this.auth.user.value?.related_registry);
    }
    //ACCOMPAGNATORE
    if (this.travel_data!.companions!.length > 0) {
      this.companion = this.travel_data!.companions![0].companion;
    }
    //TOURLEADER
    if (this.travel_data!.assignment) {
      this.assignedTourleader.setValue(
        this.travel_data!.assignment.target_user
      );
      if (
        this.travel_data?.assignment.status.id === enumAssignmentStatus.PENDING
      ) {
        this.isPending = true;
        this.requestDone = true;
      } else {
        this.isPending = false;
        this.requestDone = false;
      }
    }
    //ALLEGATI
    if (this.travel_data?.attachments) {
      this.luggage_attachment = this.travel_data.attachments.find((x) =>
        x.attachment.path.includes('luggage-insurance')
      )?.attachment;
      this.cancellation_attachment = this.travel_data.attachments.find((x) =>
        x.attachment.path.includes('cancellation-insurance')
      )?.attachment;
    }
    //PACCHETTI
    if (this.travel_data!.price_packages) {
      (this.frm_travel.get('price_packages') as FormArray)!.clear();
      for (let f of this.travel_data!.price_packages) {
        const frm_pckgs = new FormGroup({
          id: new FormControl(f.id),
          name: new FormControl(f.name),
          description: new FormControl(f.description),
          price_per_person: new FormControl<number | undefined>(
            f.price_per_person
          ),
          limited: new FormControl<boolean>(f.limited),
          tmp_children_and_infants_ok: new FormControl<boolean>(
            f.max_n_infants === 0 &&
            f.max_n_infants === 0 &&
            f.max_n_infants === 0 &&
            f.max_n_infants === 0
              ? false
              : true
          ),
          n_partecipants: new FormControl<number | undefined>(f.n_partecipants),
          max_bookings: new FormControl<number | undefined>(f.max_bookings),
          max_n_infants: new FormControl<number | undefined>(f.max_n_infants),
          max_n_children: new FormControl<number | undefined>(f.max_n_children),
          price_per_infant: new FormControl<number | undefined>(
            f.price_per_infant
          ),
          price_per_children: new FormControl<number | undefined>(
            f.price_per_children
          ),
        });

        (this.frm_travel.get('price_packages') as FormArray)!.push(frm_pckgs);
      }
    }
  }

  sendAssignmentRequest() {
    this.travelService
      .travelControllerCreateAssignment({
        id: this.draft_id ? this.draft_id : this.travel_id!,
        body: {
          target_user_id: this.assignedTourleader.value!.id,
        },
      })
      .subscribe({
        next: (res) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Richiesta inviata',
            detail: 'La richiesta è stata inviata al Tour Leader.',
          });
          this.requestDone = true;
          this.isPending = true;
          this.travel_data!.assignment = res.data;
          if (this.travel_data!.assignment) {
            this.assignedTourleader.setValue(
              this.travel_data!.assignment.target_user,
              { emitEvent: false }
            );
            (this.travel_data!.assignment as TravelAssignment) = res.data;
          }
          this.subscribeToFormChanges();
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Invio richiesta',
            detail: 'Impossibile inviare la richiesta al Tour Leader.',
          });
        },
      });
  }

  revokeAssignmentRequest() {
    this.confirmationService.confirm({
      message: 'Vuoi revocare la richiesta al Tour Leader?',
      header: 'Richiesta di assegnamento',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.travelService
          .travelControllerRevokeAssignment({
            id: this.draft_id ? this.draft_id : this.travel_id!,
            identifier: this.travel_data!.assignment.identifier,
          })
          .subscribe({
            next: (res) => {
              this.messageService.add({
                severity: 'warn',
                summary: 'Richiesta revocata',
                detail: 'La richiesta è stata revocata.',
              });
              this.requestDone = false;
              this.isPending = false;
              this.assignedTourleader.setValue(undefined, { emitEvent: false });
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Errore',
                detail: 'Impossibile revocare la richiesta.',
              });
            },
          });
      },
    });
  }

  setVisibilityValueChanges() {
    this.frm_travel.get('visibility')?.valueChanges.subscribe((v) => {
      if (v != 4) {
        this.frm_travel.get('visibility_metadata')?.setValue(undefined);
      }
      if (v === 1) {
        this.frm_travel.get('visibility_id')?.setValue(1, { emitEvent: false });
        this.isPrivate = false;
      } else {
        this.isPrivate = true;
      }
    });
    this.frm_travel.get('visibility_id')?.valueChanges.subscribe((v) => {
      if (v === 4) {
        this.throughCommunity = true;
        this.frm_travel.get('visibility_metadata')?.setValue(undefined);
        this.frm_travel
          .get('visibility_metadata')
          ?.addValidators(Validators.required);
        this.frm_travel.updateValueAndValidity();
        //this.frm_travel.get('visibility_metadata')?.markAsDirty();
      } else {
        this.throughCommunity = false;
        this.frm_travel.get('visibility_metadata')?.setValue(undefined);
      }
    });
  }

  subscribeToFormChanges() {
    this.frm_travel.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.patchDraft();
      });
    this.rangeDates.valueChanges.subscribe(() => {
      this.patchDraft();
    });
    this.player.valueChanges.subscribe(() => {
      this.patchDraft();
    });
    this.assignedTourleader.valueChanges.subscribe(() => {
      this.patchDraft();
    });
  }

  getMyCommunities() {
    this.communityService
      .communityControllerGetAll({
        limit: 50,
        skip: 0,
        creator_id: this.auth.getUserId(),
      })
      .subscribe({
        next: (res) => {
          this.communities = res.data.list;
        },
      });
  }

  getTravelTypes() {
    this.travelService.travelControllerGetCategories().subscribe({
      next: (res) => {
        this.types = res.data.list;
      },
    });
  }

  getFlightCompanies() {
    this.commonService.commonControllerGetFlightCompanies().subscribe({
      next: (res) => {
        this.companies = res.data.list;
      },
    });
  }

  getAirports() {
    this.commonService.commonControllerGetAirports().subscribe({
      next: (res) => {
        this.airports = res.data.list;
      },
    });
  }

  filterCountries(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteCountries$.next(query);
  }

  filterPlayers(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompletePlayers$.next(query);
  }

  filterLeaders(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteTourLeaders$.next(query);
  }

  addDepartureFlight() {
    const frm_dep = new FormGroup({
      id: new FormControl(-1),
      flight_company: new FormControl(undefined),
      flight_number: new FormControl(undefined),
      from_airport: new FormControl(undefined),
      to_airport: new FormControl(undefined),
      departure_date: new FormControl(undefined),
      arrival_date: new FormControl(undefined),
    });
    frm_dep.get('departure_date')?.valueChanges.subscribe((v) => {
      if (v && !frm_dep.get('arrival_date')?.value) {
        frm_dep.get('arrival_date')?.setValue(v);
      }
    });
    frm_dep.get('arrival_date')?.valueChanges.subscribe((v) => {
      if (v && !frm_dep.get('departure_date')?.value) {
        frm_dep.get('departure_date')?.setValue(v);
      }
    });
    (this.frm_travel.get('departures') as FormArray)!.push(frm_dep);
  }

  addArrivalFlight() {
    const frm_arr = new FormGroup({
      id: new FormControl(-1),
      flight_company: new FormControl(undefined),
      flight_number: new FormControl(undefined),
      from_airport: new FormControl(undefined),
      to_airport: new FormControl(undefined),
      departure_date: new FormControl(undefined),
      arrival_date: new FormControl(undefined),
    });
    frm_arr.get('departure_date')?.valueChanges.subscribe((v) => {
      if (v && !frm_arr.get('arrival_date')?.value) {
        frm_arr.get('arrival_date')?.setValue(v);
      }
    });
    frm_arr.get('arrival_date')?.valueChanges.subscribe((v) => {
      if (v && !frm_arr.get('departure_date')?.value) {
        frm_arr.get('departure_date')?.setValue(v);
      }
    });
    (this.frm_travel.get('arrivals') as FormArray)!.push(frm_arr);
  }

  get frmDepControls() {
    return <FormGroup[]>(
      (this.frm_travel.get('departures') as FormArray).controls
    );
  }
  get frmDep() {
    return this.frm_travel.get('departures') as FormArray;
  }
  get frmArrControls() {
    return <FormGroup[]>(this.frm_travel.get('arrivals') as FormArray).controls;
  }
  get frmArr() {
    return this.frm_travel.get('arrivals') as FormArray;
  }

  get frmPckgsControls() {
    return <FormGroup[]>(
      (this.frm_travel.get('price_packages') as FormArray).controls
    );
  }
  get frmPckgs() {
    return this.frm_travel.get('price_packages') as FormArray;
  }

  remove(index: number, frm: FormArray) {
    frm.removeAt(index);
  }

  get frmProgramDayControls() {
    return <FormGroup[]>(this.frm_travel.get('program') as FormArray).controls;
  }
  get frmProgramDay() {
    return this.frm_travel.get('program') as FormArray;
  }

  addProgramDay() {
    const frm_day = new FormGroup({
      title: new FormControl(''),
      description: new FormControl(''),
    });
    (this.frm_travel.get('program') as FormArray)!.push(frm_day);
  }

  addPackage() {
    const frm_pckg = new FormGroup({
      id: new FormControl(-1),
      name: new FormControl(''),
      description: new FormControl(''),
      price_per_person: new FormControl<number | undefined>(undefined),
      limited: new FormControl(false),
      tmp_children_and_infants_ok: new FormControl(true),
      n_partecipants: new FormControl<number | undefined>(undefined),
      max_bookings: new FormControl<number | undefined>(undefined),
      max_n_infants: new FormControl<number | undefined>({
        value: undefined,
        disabled: false,
      }),
      max_n_children: new FormControl<number | undefined>({
        value: undefined,
        disabled: false,
      }),
      price_per_infant: new FormControl<number | undefined>({
        value: undefined,
        disabled: false,
      }),
      price_per_children: new FormControl<number | undefined>({
        value: undefined,
        disabled: false,
      }),
    });
    (this.frm_travel.get('price_packages') as FormArray)!.push(frm_pckg);
  }

  openTravelImagePicker() {
    debugger;
    this.imagePickerRef = this.dialogService.open(ModalImagePickerComponent, {
      header: 'Aggiungi una foto della destinazione',
      width: '50%',
      styleClass: 'modal-res',
      data: {
        squared: false,
      },
    });
    this.imagePickerRef.onClose.subscribe((p: { profile: Blob }) => {
      this.imgLoading = true;
      if (p) {
        this.travelService
          .travelControllerAddPicture({
            id: this.draft_id! || this.travel_id!,
            body: { picture: p.profile },
          })
          .subscribe({
            next: (res) => {
              this.travel_img = res.data.medias?.sort(
                (a, b) => a.media.id - b.media.id
              );
              this.messageService.add({
                severity: 'success',
                summary: 'Immagine viaggio',
                detail: "L'immagine è stata caricata correttamente.",
              });
              this.imgLoading = false;
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Immagine viaggio',
                detail: "Impossibile caricare l'immagine.",
              });
              this.imgLoading = false;
            },
          });
      } else {
        this.imgLoading = false;
      }
    });
    this.imgLoading = false;
  }

  openCloudImagePickerModal() {
    this.imageFromCloudPickerRef = this.dialogService.open(
      CloudImagePickerComponent,
      {
        header: "Cerca un'immagine per il viaggio",
        width: '70%',
      }
    );
    this.imgLoading = true;
    this.imageFromCloudPickerRef.onClose.subscribe(
      (p: { images: CloudSearchResponseItem[] }) => {
        const bodies: DtoCreateMediaFromCloud[] = [];
        for (let i = 0; i < p.images.length; i++) {
          bodies.push({
            id: p.images[i].id,
            name: p.images[i].name,
            path: p.images[i].urls.full,
            cloud_service: 'UNS',
            metadata: p.images[i],
          });
        }
        this.travelService
          .travelControllerAddCountryPictureFromCloud({
            id: this.draft_id! || this.travel_id!,
            body: {
              items: bodies,
            },
          })
          .subscribe({
            next: (res) => {
              this.travel_img = res.data.medias?.sort(
                (a, b) => a.media.id - b.media.id
              );
              console.log('DOPO upload - travel_img:', this.travel_img);
              this.messageService.add({
                severity: 'success',
                summary: 'Immagine viaggio',
                detail: "L'immagine è stata caricata correttamente.",
              });
              this.imgLoading = false;
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Modifica destinazioni',
                detail: "Impossibile caricare l'immagine.",
              });
              this.imgLoading = false;
            },
          });
      }
    );
    this.imgLoading = false;
  }

  deleteImg(id: number, index: number) {
    this.confirmationService.confirm({
      message: 'Vuoi eliminare questa immagine?',
      header: 'Eliminazione',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.travelService
          .travelControllerDeleteImage({
            id: this.draft_id! || this.travel_id!,
            media_id: id,
          })
          .subscribe({
            next: (res) => {
              this.travel_img!.splice(index, 1);
              this.messageService.add({
                severity: 'success',
                summary: 'Eliminazione',
                detail: "L'immagine è stata eliminata.",
              });
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Eliminazione',
                detail: "Impossibile eliminare l'immagine.",
              });
            },
          });
      },
    });
  }

  get frmServiceControls() {
    return <FormGroup[]>(
      (this.frm_travel.get('addl_services') as FormArray).controls
    );
  }
  get frmService() {
    return this.frm_travel.get('addl_services') as FormArray;
  }

  addService() {
    const frm_service = new FormGroup({
      title: new FormControl(''),
      description: new FormControl(''),
      price: new FormControl<number | undefined>(undefined),
    });
    (this.frm_travel.get('addl_services') as FormArray)!.push(frm_service);
  }

  goTo(n: number) {
    this.menuIndex = n;
    // setTimeout(() => {
    //   this.applyFormErrors();
    // }, 0);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  redirect() {
    this.confirmationService.confirm({
      message:
        'Vuoi lasciare questa pagina? Potrai pubblicarla dalla tua area privata in un secondo momento.',
      header: 'Salva bozza',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.router.navigate(['/user/travels'], {
          queryParams: { tab: 'drafts' },
        });
      },
    });
  }

  updateFlightsId(
    flights: FlightDraftWrapper[] | undefined,
    type: 'arrivals' | 'departures'
  ) {
    if (!flights || flights.length === 0) {
      return;
    }
    const targetFormGroup =
      type === 'arrivals' ? this.frmArrControls : this.frmDepControls;
    flights.forEach((flight, i) => {
      targetFormGroup[i]
        .get('id')!
        .setValue(flight.flight.id, { emitEvent: false });
    });
  }

  updatePackagesId(packages: TravelPackage[] | undefined) {
    if (!packages || packages.length === 0) {
      return;
    }
    const targetFormGroup = this.frmPckgsControls;
    packages.forEach((pckg, i) => {
      targetFormGroup[i].get('id')!.setValue(pckg.id, { emitEvent: false });
    });
  }

  openCompanionModal() {
    this.newCompanionRef = this.dialogService.open(ModalNewCompanionComponent, {
      header: 'Nuovo accompagnatore',
      width: '60%',
      styleClass: 'modal-res',
      data: {
        companion: this.companion,
      },
    });
    this.newCompanionRef.onClose.subscribe((c: CompanionItem) => {
      if (c) {
        this.companion = c;
        this.patchDraft();
      }
    });
  }

  checkPckgAdultsOnly(frm: FormGroup) {
    if (frm.get('tmp_children_and_infants_ok')?.value === false) {
      frm.get('price_per_infant')?.setValue(0);
      frm.get('price_per_children')?.setValue(0);
      frm.get('max_n_children')?.setValue(0);
      frm.get('max_n_infants')?.setValue(0);
    } else {
      frm.get('price_per_infant')?.setValue(undefined);
      frm.get('price_per_children')?.setValue(undefined);
      frm.get('max_n_children')?.setValue(undefined);
      frm.get('max_n_infants')?.setValue(undefined);
    }
  }

  checkLimitedPckg(frm: FormGroup) {
    if (frm.get('limited')?.value === true) {
      frm.get('max_bookings')?.setValue(undefined);
    }
  }

  patchDraft() {
    delete this.frm_travel.value.visibility;
    for (let p of this.frm_travel.get('price_packages')?.value) {
      delete p.tmp_children_and_infants_ok;
    }
    const bodyUp: DtoTravelCreateDraft = this.frm_travel.value as any;
    if (this.rangeDates.value) {
      bodyUp.from_date = this.rangeDates.value[0]
        ? correctDate(this.rangeDates.value[0]).toISOString()
        : undefined;
      bodyUp.to_date = this.rangeDates.value[1]
        ? correctDate(this.rangeDates.value[1]).toISOString()
        : undefined;
    }
    if (this.frm_travel.get('countries_iso')?.value != null) {
      bodyUp.countries_iso = this.frm_travel
        .get('countries_iso')!
        .value.map((c: CountryItem) => c.ISO);
    }
    if (this.player.value) {
      bodyUp.player_id = this.player.value.id;
    }
    if (this.companion && this.companion.id) {
      bodyUp.companion_id = this.companion.id;
    }
    if (bodyUp.payoff) {
      this.sanitizeContent(bodyUp.payoff);
    }
    if (bodyUp.summary) {
      this.sanitizeContent(bodyUp.summary);
    }
    if (
      bodyUp.checkout_advance != null ||
      bodyUp.checkout_advance != undefined
    ) {
      bodyUp.checkout_full_payment = false;
    } else {
      bodyUp.checkout_full_payment = true;
    }

    if (this.payoff_due_date_control.value) {
      bodyUp.payoff_due_date = this.payoff_due_date_control.value.toISOString();
    }
    if (bodyUp.visibility_id === 4) {
      bodyUp.visibility_metadata = this.communities.filter((c) =>
        (bodyUp.visibility_metadata as any[]).includes(c.id)
      );
    }
    this.travelService
      .travelControllerSaveDraft({
        id: this.draft_id!,
        body: bodyUp,
      })
      .subscribe({
        next: (res) => {
          this.loading = true;
          this.updateFlightsId(res.data.departures, 'departures');
          this.updateFlightsId(res.data.arrivals, 'arrivals');
          this.updatePackagesId(res.data.price_packages);
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Bozza viaggio',
            detail: 'Impossibile salvare la bozza.',
          });
        },
      });
  }

  publish() {
    this.confirmationService.confirm({
      message: 'Vuoi pubblicare questo viaggio?',
      header: 'Pubblicazione',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.travelService
          .travelControllerPublishDraft({
            id: this.draft_id!,
          })

          .subscribe({
            next: (res) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Pubblicazione viaggio',
                detail: 'Il viaggio è stato pubblicato.',
              });
              if (this.travel_data && this.travel_data.countries!.length > 0) {
                const slugifyNameTravel = this.slugifyPipe.transform(
                  this.travel_data.name!
                );
                this.router.navigate(
                  [
                    `/viaggi-di-gruppo/${
                      this.travel_data.countries![0].country.ISO
                    }/${this.travel_data.countries![0].country.name}/${
                      this.travel_data.id
                    }/${slugifyNameTravel}`,
                  ],
                  { queryParams: { share: 'on' } }
                );
              }
              if (
                this.frm_travel.value &&
                this.frm_travel.get('countries_iso')?.value
              ) {
                const slugifyNameTravel = this.slugifyPipe.transform(
                  this.frm_travel.value.name!
                );
                this.router.navigate(
                  [
                    `/viaggi-di-gruppo/${
                      this.frm_travel.get('countries_iso')?.value[0]
                    }/${this.frm_travel.get('countries_iso')?.value[0]}/${
                      this.draft_id
                    }/${slugifyNameTravel}`,
                  ],
                  { queryParams: { share: 'on' } }
                );
              }
            },
            error: (err) => {
              try {
                this.form_section_validation.forEach((value) => {
                  value.valid = true;
                });
                console.log(this.travel_data);
                this.applyFormErrors(err.error.validationErrors.data.errors);
                this.messageService.add({
                  severity: 'error',
                  summary: 'Pubblicazione viaggio',
                  detail:
                    'Impossibile pubblicare il viaggio. Controlla che tutti i campi del form siano correttamente compilati.',
                });
              } catch {}
            },
          });
      },
    });
  }

  applyFormErrors(errors: any) {
    this.applyErrorsRecursive(errors, this.frm_travel);
  }

  private sectionForPath(path: string): string | undefined {
    // Controllo se il path.key corrisponde ad uno o più form_section_validation.fields
    for (const [section, key] of this.form_section_validation.entries()) {
      if (key.fields.includes(path)) {
        return section;
      }
    }
    return undefined;
  }

  private applyErrorsRecursive(
    // Oggetto di errori dal backend
    errors: any,
    // Il formGroup/formArray/formControl su cui applicare quegli errori
    control: AbstractControl,
    // Accumulatore dei contenitori in cui si trovano gli errori (es. 'price_packages')
    path: string[] = []
  ): void {
    // Per ogni valore dell'oggetto errors ritornato dal BE:
    Object.keys(errors).forEach((key) => {
      // Mi tengo da parte la chiave dell'errore per controllare le varie casistiche
      const errValue = errors[key];
      // Mi tengo da parte il path dell'errore e l'errore stesso
      const nextPath = [...path, key]; // es. ['price_packages', '0', 'description']
      // Manipolo il path in modo da ritornare una stringa 'parentKey.childKey'
      const pathString = nextPath
        .filter((p) => isNaN(+p)) // rimuove indici numerici
        .join('.'); // es. "price_packages.description"

      // 1. Caso stringa
      if (typeof errValue === 'string') {
        // Prendo il FormControl associato alla key del BE
        const child = (control as FormGroup).get(key);
        // Se il FormControl esiste, setto l'errore e lo segno come dirty
        if (child) {
          child.setErrors({ backend: errValue });
          child.markAsDirty();
          // Controllo a quale section appartiene il campo e setto la validità della section (map) a false
          const section = this.sectionForPath(pathString);
          if (section) {
            this.form_section_validation.get(section)!.valid = false;
          }
        }
        return;
      }

      // 2. Caso array
      if (Array.isArray(errValue)) {
        // Per ogni elemento dell'array, prendo il FormArray associato alla key del BE ed il suo index
        errValue.forEach((itemErr, idx) => {
          const arrayCtrl = (control as FormGroup).get(key) as FormArray;

          const pathString = [...path, key] // es. ['departures']
            .filter((p) => isNaN(+p)) // rimuovo indici numerici
            .join('.'); // es. "departures"

          // Se manca l’elemento idx marco comunque la sezione
          if (!arrayCtrl || !arrayCtrl.at(idx)) {
            const section = this.sectionForPath(
              pathString + '.' + Object.keys(itemErr)[0]
            );
            // es. "departures.flight_company" → section_1
            if (section) {
              this.form_section_validation.get(section)!.valid = false;
            }
            return;
          }

          // Se l’elemento in quell'index esiste, richiamo ricorsivamente applyErrorsRecursive() su quell’formArray in quell'index
          this.applyErrorsRecursive(itemErr, arrayCtrl.at(idx), [
            ...path,
            key,
            String(idx),
          ]);
        });
        return;
      }

      // 3. Caso oggetto annidato
      if (typeof errValue === 'object' && errValue !== null) {
        // Se control è un formGroup, chiamo ricorsivamente la funzione per gestire anche i suoi figli
        const groupCtrl = (control as FormGroup).get(key);
        if (groupCtrl) {
          this.applyErrorsRecursive(errValue, groupCtrl, nextPath);
        }
      }
    });
  }

  updateTravel() {
    if ((this.travel_data as TravelItem).availability?.booked! > 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Modifica viaggio',
        detail:
          'Impossibile modificare un viaggio già prenotato da altri utenti.',
      });
    } else {
      delete this.frm_travel.value.visibility;
      for (let p of this.frm_travel.get('price_packages')?.value) {
        delete p.tmp_children_and_infants_ok;
      }
      const bodyUp: DtoTravelCreate = this.frm_travel.value as any;
      if (this.rangeDates.value) {
        bodyUp.from_date = correctDate(this.rangeDates.value[0]!).toISOString();
        bodyUp.to_date = correctDate(this.rangeDates.value[1]!).toISOString();
      }
      if (this.frm_travel.get('countries_iso')?.value != null) {
        bodyUp.countries_iso = this.frm_travel
          .get('countries_iso')!
          .value.map((c: CountryItem) => c.ISO);
      }
      if (this.player.value) {
        bodyUp.player_id = this.player.value.id;
      }
      if (this.companion?.id) {
        bodyUp.companion_id = this.companion.id;
      }
      if (bodyUp.payoff) {
        this.sanitizeContent(bodyUp.payoff);
      }
      if (bodyUp.summary) {
        this.sanitizeContent(bodyUp.summary);
      }

      let add_services = this.frm_travel.controls['addl_services'].value;
      for (let a of add_services) {
        bodyUp.addl_services = add_services.filter((x: any) => x.price != null);
      }

      if (
        bodyUp.checkout_advance != null ||
        bodyUp.checkout_advance != undefined
      ) {
        bodyUp.checkout_full_payment = false;
      } else {
        bodyUp.checkout_full_payment = true;
      }

      this.travelService
        .travelControllerSaveTravel({
          id: this.travel_id!,
          body: bodyUp,
        })
        .subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Modifica viaggio',
              detail: 'Il viaggio è stato modificato.',
            });
            this.router.navigateByUrl('/user/travels');
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Modifica viaggio',
              detail:
                'Impossibile modificare il viaggio. Controlla che tutti i campi siano completi.',
            });
            this.form_section_validation.forEach((value) => {
              value.valid = true;
            });
            this.applyFormErrors(err.error.validationErrors.data.errors);
          },
        });
    }
  }

  openFileImport() {
    this.openFileRef = this.dialogService.open(ModalFilePickerComponent, {
      header: 'Importa file',
      width: '50%',
      styleClass: 'modal-res',
      data: {
        onlyPdf: true,
      },
    });
    this.openFileRef.onClose.subscribe((v: { file: any }) => {
      if (v) {
        this.loading_luggage_attachment = true;
        this.travelService
          .travelControllerAddAttachment({
            id: this.draft_id! | this.travel_id!,
            body: {
              attachment: v.file,
              type: 'luggage-insurance',
            },
          })
          .subscribe({
            next: (res) => {
              this.luggage_attachment = res.data.attachments?.find((x) =>
                x.attachment.path.includes('luggage-insurance')
              )?.attachment;
              this.cancellation_attachment = res.data.attachments?.find((x) =>
                x.attachment.path.includes('cancellation-insurance')
              )?.attachment;
              this.messageService.add({
                severity: 'success',
                summary: 'Assicurazione',
                detail: 'Il file è stato importato correttamente.',
              });
              this.loading_luggage_attachment = false;
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Assicurazione',
                detail: 'Impossibile importare il file.',
              });
              this.loading_luggage_attachment = false;
            },
          });
      }
    });
  }

  removeInsurance() {
    if (this.luggage_attachment) {
      this.confirmationService.confirm({
        message: "Vuoi rimuovere l'assicurazione?",
        header: 'Eliminazione',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sì',
        rejectLabel: 'Annulla',
        acceptButtonStyleClass: 'bg-dialog p-button-sm',
        rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
        accept: () => {
          this.travelService
            .travelControllerDeleteAttachment({
              id: this.draft_id! || this.travel_id!,
              media_id: this.luggage_attachment?.id!,
            })
            .subscribe({
              next: (res) => {
                this.luggage_attachment = undefined;
                this.messageService.add({
                  severity: 'success',
                  summary: 'Eliminazione',
                  detail: "L'assicurazione è stata rimossa",
                });
              },
              error: (err) => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Eliminazione',
                  detail: "Impossibile rimuovere l'assicurazione.",
                });
              },
            });
        },
      });
    }
  }

  openFileImportCancellation() {
    this.openFileRef = this.dialogService.open(ModalFilePickerComponent, {
      header: 'Importa file',
      width: '50%',
      styleClass: 'modal-res',
      data: {
        onlyPdf: true,
      },
    });
    this.openFileRef.onClose.subscribe((v: { file: any }) => {
      if (v) {
        this.loading_cancellation_attachment = true;
        this.travelService
          .travelControllerAddAttachment({
            id: this.draft_id! | this.travel_id!,
            body: {
              attachment: v.file,
              type: 'cancellation-insurance',
            },
          })
          .subscribe({
            next: (res) => {
              this.cancellation_attachment = res.data.attachments?.find((x) =>
                x.attachment.path.includes('cancellation-insurance')
              )?.attachment;
              this.messageService.add({
                severity: 'success',
                summary: 'Assicurazione',
                detail: 'Il file è stato importato correttamente.',
              });
              this.loading_cancellation_attachment = false;
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Assicurazione',
                detail: 'Impossibile importare il file.',
              });
              this.loading_cancellation_attachment = false;
            },
          });
      }
    });
  }

  removeCancellation() {
    if (this.luggage_attachment) {
      this.confirmationService.confirm({
        message: "Vuoi rimuovere l'assicurazione?",
        header: 'Eliminazione',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sì',
        rejectLabel: 'Annulla',
        acceptButtonStyleClass: 'bg-dialog p-button-sm',
        rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
        accept: () => {
          this.travelService
            .travelControllerDeleteAttachment({
              id: this.draft_id! || this.travel_id!,
              media_id: this.cancellation_attachment?.id!,
            })
            .subscribe({
              next: (res) => {
                this.cancellation_attachment = undefined;
                this.messageService.add({
                  severity: 'success',
                  summary: 'Eliminazione',
                  detail: "L'assicurazione è stata rimossa",
                });
              },
              error: (err) => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Eliminazione',
                  detail: "Impossibile rimuovere l'assicurazione.",
                });
              },
            });
        },
      });
    }
  }

  goBack() {
    this.menuIndex -= 1;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  goFurther() {
    this.menuIndex += 1;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  sanitizeContent(content: string) {
    //return content.replace(/&nbsp;/g, ' ');
    const doc = new DOMParser().parseFromString(content, 'text/html');
    return doc.body.innerHTML.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
  }
}
